import { Type } from '@angular/core';

export class CgpComponentBrowserItem {
  constructor(public component: Type<any>, public data: any) {}
}
